import {
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import CommonLinearProgress from "../../../../../component/Linearprogress";
import {
  DotColor,
  StatusChange,
  TableContainerBorder,
} from "../../../../common-components/StyledComponents";
import AvatarImage from "./Avatar.png";

export const getColor = (score) => {
  let color;
  const roundedScore = Math.round(score);

  if (roundedScore <= 60) {
    color = "#F79009";
  } else if (roundedScore > 60 && roundedScore <= 80) {
    color = "#7F56D9";
  } else if (roundedScore > 80 && roundedScore <= 100) {
    color = "#17B26A";
  }

  return color;
};

function Results() {
  const sortedData = [
    {
      id: "100",
      name: "Zahir Mays",
      status: "Visionary",
      Type: "Tier 1",
      Onboarded: "Dec 6 2024",
      email: "olivia@mail.com",
      avatarUrl: AvatarImage,
      candidate_name: "Zahir Mays",
      score: 90,
    },
    {
      id: "V-101",
      name: "Phoenix Baker",
      status: "Executor",
      Type: "Tier 2",
      Onboarded: "Dec 6 2024",
      email: "lana@mail.com",
      avatarUrl: "https://mui.com/static/images/avatar/2.jpg",
      score: 79,
    },
    {
      id: "102",
      name: "Lana Steiner",
      status: "Executor",
      Type: "Tier 3",
      Onboarded: "Dec 6 2024",
      email: "kate@mail.com",
      avatarUrl: "https://mui.com/static/images/avatar/3.jpg",
      score: 80,
    },
    {
      id: "103",
      name: "Jacob Jones",
      status: "Collaborator",
      Type: "Tier 2",
      Onboarded: "Dec 6 2024",
      email: "lana@mail.com",
      avatarUrl: "https://mui.com/static/images/avatar/7.jpg",
      score: 60,
    },
    // {
    //   id: "103",
    //   name: "Jane Cooper",
    //   status: "Executor",
    //   Type: "Tier 2",
    //   Onboarded: "Dec 6 2024",
    //   email: "lana@mail.com",
    //   avatarUrl: "https://mui.com/static/images/avatar/4.jpg",
    //   score: 70,
    // },
    // {
    //   id: "103",
    //   name: "Mathew",
    //   status: "Executor",
    //   Type: "Tier 2",
    //   Onboarded: "Dec 6 2024",
    //   email: "lana@mail.com",
    //   avatarUrl: "https://mui.com/static/images/avatar/1.jpg",
    //   score: 70,
    // },
    // {
    //   id: "103",
    //   name: "Robert Fox",
    //   status: "Executor",
    //   Type: "Tier 2",
    //   Onboarded: "Dec 6 2024",
    //   email: "lana@mail.com",
    //   avatarUrl: "https://mui.com/static/images/avatar/2.jpg",
    //   score: 70,
    // },
    // {
    //   id: "103",
    //   name: "Jenny Wilson",
    //   status: "Executor",
    //   Type: "Tier 2",
    //   Onboarded: "Dec 6 2024",
    //   email: "lana@mail.com",
    //   avatarUrl: "https://mui.com/static/images/avatar/2.jpg",
    //   score: 70,
    // },
    // {
    //   id: "103",
    //   name: "Brooklyn Simson",
    //   status: "Executor",
    //   Type: "Tier 2",
    //   Onboarded: "Dec 6 2024",
    //   email: "lana@mail.com",
    //   avatarUrl: "https://mui.com/static/images/avatar/2.jpg",
    //   score: 70,
    // },
    // {
    //   id: "103",
    //   name: "Olivia",
    //   status: "Executor",
    //   Type: "Tier 2",
    //   Onboarded: "Dec 6 2024",
    //   email: "lana@mail.com",
    //   avatarUrl: "https://mui.com/static/images/avatar/2.jpg",
    //   score: 70,
    // },
    // {
    //   id: "103",
    //   name: "Esther Howard",
    //   status: "Executor",
    //   Type: "Tier 2",
    //   Onboarded: "Dec 6 2024",
    //   email: "lana@mail.com",
    //   avatarUrl: "https://mui.com/static/images/avatar/2.jpg",
    //   score: 70,
    // },
  ];

  const headerData = ["Leadership Team", "Status", "Criticality Score"];

  return (
    <TableContainerBorder style={{ marginTop: "0px" }}>
      <Table>
        <TableHead>
          <TableRow>
            {headerData.map((item, index) => (
              <TableCell key={index}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((row) => (
            <TableRow key={row.id}>
              <TableCell width={"60%"}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <Avatar alt={row.name} src={row.avatarUrl} />
                  </Grid>
                  <Grid item>{row.name}</Grid>
                </Grid>
              </TableCell>
              <TableCell width={"20%"}>
                <StatusChange>
                  <DotColor
                    color={
                      row.status === "Visionary"
                        ? "#17B26A"
                        : row.status === "Executor"
                        ? "#9E77ED"
                        : row.status === "Collaborator"
                        ? "#A98784"
                        : "#A98784"
                    }
                  />
                  {row.status}
                </StatusChange>
              </TableCell>
              <TableCell align="left" width={"20%"}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <CommonLinearProgress
                    variant="determinate"
                    value={row.score}
                    flex={1}
                    height={"8px"}
                    borderRadius={"4px"}
                    barbackgroundColor={getColor(row.score)}
                  />
                  <Typography>{row.score}%</Typography>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainerBorder>
  );
}

export default Results;
